<template>
  <div>
     <template class="table-head">
        <el-table style="width: 100%" @current-change="handleCurrentChange" highlight-current-row  :data="networkDotList" border height="200" ref="dragTable">
            <el-table-column align="center" show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in networkDotColumnItem" :key="index">
                    <template slot-scope="scope">
                        <span class="center">
                            <el-input :class="{red: scope.row.hasValue}" clearable
                                 v-if="item.prop==='supplierAmount'" v-model="scope.row[item.prop]" :disabled ="ifConfirm" ></el-input>
                            <el-input clearable maxlength="50" v-else-if="item.prop==='supplierMsg'" v-model.trim="scope.row[item.prop]" :disabled ="ifConfirm"></el-input>
                            <span v-else>{{scope.row[item.prop]}}</span>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        <div class="pagination">
            <el-pagination small layout="prev, pager, next" @current-change="pageChange" :total="total"></el-pagination>
        </div>
     </template>
  </div>
</template>

<script>
export default {
    props: {
        networkDotColumnItem: {
            type: Array
        },
        tableDataListsLenth: {
            type: String
        },
        tableDataLists: {
            type: Object
        },
        ifConfirm: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            total: 0,
            supplierAmountTem: [],
            networkDotList: []
        };
    },
    methods: {
        handleCurrentChange(row) {
            row && this.$emit('apBillDeDetail', 1, row); // 调用费用明细的事件， 页码， 参数
        },
        pageChange(page) {
            this.$emit('apBillDetail', page);
        },
        saveDistributionDetails() { // 保存
            const datas = [];
            for (let i = 0; i < this.networkDotList.length; i++) {
                if (this.networkDotList[i].supplierAmount === '' || this.networkDotList[i].supplierAmount === undefined) {
                    return this.$message.warning('确认费用金额不能为空');
                }
                if (Number(this.networkDotList[i].supplierAmount) !== this.networkDotList[i].amount &&
                (this.networkDotList[i].supplierMsg === undefined || this.networkDotList[i].supplierMsg === '')) {
                    this.$message.warning('确认金额不一致，请备注原因');
                    return;
                } else {
                    const data = { // 回传出去
                        feeTaskCode: this.networkDotList[i].feeTaskCode,
                        jobId: this.networkDotList[i].jobId,
                        supplierAmount: this.networkDotList[i].supplierAmount,
                        supplierMsg: this.networkDotList[i].supplierMsg
                    };
                    datas.push(data);
                }
            }
            this.$emit('saveApBillDetail', datas);
        },
        confirm() { // 确认提交
            this.tableArray = this.networkDotList.every(item => {
                return item.supplierAmount !== undefined && item.supplierAmount !== '';
            });
            if (!this.tableArray) {
                return this.$message.warning('确认费用金额不能为空');
            } else {
                for (let i = 0; i < this.networkDotList.length; i++) {
                    if (Number(this.networkDotList[i].supplierAmount) !== this.networkDotList[i].amount &&
                (this.networkDotList[i].supplierMsg === undefined || this.networkDotList[i].supplierMsg === '')) {
                        return this.$message.warning('确认金额不一致，请备注原因');
                    }
                }
            }
            if (this.networkDotList.map(item => item.supplierAmount).toString() === this.supplierAmountTem.toString()) {
                this.$emit('confirmOk');
            } else {
                return this.$message.warning('数据已更改，请先保存之后再提交');
            }
        }
    },
    watch: {
        tableDataLists: {
            handler(newValue) {
                this.networkDotList = JSON.parse(JSON.stringify(newValue.list));
                this.supplierAmountTem = newValue.list.map(item => item.supplierAmount);
                this.total = newValue.totalCount;
            },
            deep: true
        }
    }

};
</script>

<style lang="less">

</style>